import { render, staticRenderFns } from "./AdminMessagesAdd.vue?vue&type=template&id=758d7d26&"
import script from "./AdminMessagesAdd.vue?vue&type=script&lang=js&"
export * from "./AdminMessagesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports